import { ClientVisitSummaryDto, VisitDetail, VisitQueryDto } from './entity';

//toto odstranit po úpravě na BE
type VisitLike = Pick<
  VisitQueryDto | ClientVisitSummaryDto,
  | 'id'
  | 'date'
  | 'dateTo'
  | 'visitStatus'
  | 'note'
  | 'autor'
  | 'client'
  | 'user'
  | 'userId'
  | 'visitServices'
  | 'procedures'
  | 'loyaltyPointsGained'
  | 'loyaltyPointsUsed'
  | 'deposit'
  | 'depositStatus'
  | 'servicePaidStatus'
  | 'productsPaidStatus'
  | 'paidPrice'
> & { totalSalesRevenue?: number };

export const mapSingleVisitDetail = (summary: VisitLike): VisitDetail => ({
  visit: {
    id: summary.id,
    dateFrom: summary.date,
    dateTo: summary.dateTo,
    visitStatus: summary.visitStatus,
    note: summary.note,
    autor: summary.autor,
  },
  client: summary.client,
  worker: { ...summary.user, teamId: summary.userId },
  services: summary.visitServices.map(vs => vs.service),
  visitServiceId: summary.visitServices[0]?.id ?? '',
  procedures: summary.procedures,
  loyalty: {
    loyaltyPointsGained: summary.loyaltyPointsGained,
    loyaltyPointsUsed: summary.loyaltyPointsUsed,
  },
  financials: {
    deposit: summary.deposit,
    depositStatus: summary.depositStatus,
    servicePaidStatus: summary.servicePaidStatus,
    productsPaidStatus: summary.productsPaidStatus,
    paidPrice: summary.paidPrice,
    totalSalesRevenue: summary.totalSalesRevenue,
  },
});

export const mapVisitDetail = (data: ClientVisitSummaryDto[]): VisitDetail[] =>
  data.map(mapSingleVisitDetail);
